import React from "react";
import styled from "styled-components";
import { IBlog } from "types/interfaces/blog/IBlog";
import { Typography } from "@beamcloud/design-system";
import ArticleCard from "./ArticleCard";

interface IProps {
  blogs: IBlog[];
}

const RelatedBlogs = ({ blogs }: IProps) => {
  return (
    <Container>
      <Content>
        <Typography tag="h3" variant="title3Xl" color="gray100">
          Keep Reading
        </Typography>
        <Articles>
          {blogs.map(blog => (
            <ArticleCard key={blog.id} {...blog} />
          ))}
        </Articles>
      </Content>
    </Container>
  );
};

export default RelatedBlogs;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 96px 0px;
  background: linear-gradient(180deg, #1d1f24 0%, rgba(23, 24, 28, 0) 100%);
  width: 100vw;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 64px;
  width: min(960px, 100vw);
  margin: auto;

  @media (max-width: 959px) {
    align-items: center;
  }
`;

const Articles = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px;
  gap: 48px;

  @media (max-width: 959px) {
    justify-content: center;
  }
`;
